/**
 * documentsreducer.js
 * Created by calhosh on 9/9/2020.
 */
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function documentReducer(state = initialstate.documents, action) {
	switch (action.type) {
		case types.GET_ALL_DOCUMENTS:
			if (action.response) {
				return action.response.data || state;
			}
			return state;
		default:
			return state;
	}
}
